module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-search"
  }, [_c('mt-search', {
    attrs: {
      "autofocus": "",
      "result": _vm.filterResult
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b989596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/search.vue
// module id = 275
// module chunks = 0